/**
 * ob-max-one.js — Bendita Cânfora
 *
 * Garante quantidade máxima 1 para produtos de order bump no carrinho lateral.
 * A UI de incremento já é removida no Liquid (snippets/cart-drawer.liquid);
 * este script é a rede de segurança para quando a quantidade sobe por outro
 * caminho (cross-sell adicionando item já presente, duplo clique, cart antigo).
 *
 * Depende de: data-ob-line / data-ob-key / data-ob-qty renderizados no <tr>.
 */
(function () {
  'use strict';

  var MAX = 1;
  var SELECTOR_ROW = 'cart-drawer-items tr[data-ob-line="true"]';
  var busy = false;
  var scheduled = null;

  function cartChangeUrl() {
    return (window.routes && window.routes.cart_change_url) || '/cart/change';
  }

  function cartUrl() {
    return (window.routes && window.routes.cart_url) || '/cart';
  }

  function overflowRows() {
    return Array.prototype.slice.call(document.querySelectorAll(SELECTOR_ROW)).filter(function (row) {
      return parseInt(row.getAttribute('data-ob-qty'), 10) > MAX;
    });
  }

  function changeLine(key) {
    return fetch(cartChangeUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: MAX })
    }).then(function (response) {
      return response.json();
    });
  }

  function rerenderDrawer() {
    return fetch(cartUrl() + '?section_id=cart-drawer')
      .then(function (response) {
        return response.text();
      })
      .then(function (text) {
        var html = new DOMParser().parseFromString(text, 'text/html');
        ['cart-drawer-items', '.cart-drawer__footer', 'free-shipping-bar'].forEach(function (selector) {
          var target = document.querySelector(selector);
          var source = html.querySelector(selector);
          if (target && source) target.replaceWith(source);
        });
      });
  }

  function publishCartUpdate(cartData) {
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ob-max-one', cartData: cartData });
      }
    } catch (error) {
      /* pub/sub ausente: o re-render acima já cobriu a UI */
    }
  }

  function enforce() {
    if (busy) return;

    var rows = overflowRows();
    if (!rows.length) return;

    busy = true;

    var chain = Promise.resolve(null);

    rows.forEach(function (row) {
      var key = row.getAttribute('data-ob-key');
      if (!key) return;
      // marca localmente antes da resposta para não reentrar no MutationObserver
      row.setAttribute('data-ob-qty', String(MAX));
      chain = chain.then(function () {
        return changeLine(key);
      });
    });

    chain
      .then(function (cartData) {
        return rerenderDrawer().then(function () {
          publishCartUpdate(cartData);
        });
      })
      .catch(function (error) {
        console.error('[ob-max-one]', error);
      })
      .finally(function () {
        busy = false;
      });
  }

  function scheduleEnforce() {
    if (scheduled) return;
    scheduled = window.setTimeout(function () {
      scheduled = null;
      enforce();
    }, 60);
  }

  function boot() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    // Qualquer caminho que altere o carrinho acaba re-renderizando o drawer,
    // então observar o DOM cobre cross-sell, combo, product form e cart.js.
    new MutationObserver(scheduleEnforce).observe(drawer, { childList: true, subtree: true });

    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
          if (event && event.source === 'ob-max-one') return;
          scheduleEnforce();
        });
      }
    } catch (error) {
      /* sem pub/sub o observer já basta */
    }

    scheduleEnforce();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
